import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import Typed from 'typed.js';
import Marquee from 'react-fast-marquee';

import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { servicelistdata } from '../assets/servicelistdata';
import PageHeader from '../pages/PageHeader';
import ChooseUsSection from '../pages/ChooseUsSection';
import Testimonial from '../pages/Testimonial';
import serviceList from '../assets/serviceList';
const OurService = () => {
  const [services, setServices] = useState([
    'Mobile App Development',
    'Web Development',
    'Graphic Design Services',
    'Custom Software Development',
    'Digital Marketing',
    'SEO Optimization'
  ]);

  
  useEffect(() => {
    window.scrollTo(0, 0); // This will move the user to the top of the page
  }, []);
  
  const getFirst40Words = (text) => {
    const words = text.split(' '); // Split the description into words
    if (words.length > 23) {
      return words.slice(0, 23).join(' ')  // Return first 40 words with ellipsis
    }
    return text; // If less than 40 words, return the original text
  };
  return (
    <div>
      
<Helmet>
  {/* Meta Charset and Viewport */}
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />

  {/* Meta Title */}
  <title>Our Services | AppNexts - Expert App Development, Web Development, SEO & More</title>

  {/* Meta Description */}
  <meta
    name="description"
    content="Explore the wide range of services provided by AppNexts, including App Development, Web Development, SEO, Graphic Design, Video Editing, and Data Scraping. Empower your business with our innovative digital solutions."
  />

  {/* Meta Keywords */}
  <meta
    name="keywords"
    content="app development, web development, SEO services, graphic design, video editing, data scraping, digital solutions, business growth, e-commerce solutions, responsive web design, mobile app development, UX/UI design, custom software solutions, branding services"
  />

  {/* General SEO Tags */}
  <meta name="robots" content="index, follow" />
  <meta httpEquiv="Content-Language" content="en" />
  <meta property="og:locale" content="en_US" />

  {/* Canonical URL */}
  <link rel="canonical" href="https://www.appnexts.com/our-services" />

  {/* Open Graph Tags */}
  <meta property="og:title" content="Our Services | AppNexts - Expert Digital Solutions" />
  <meta
    property="og:description"
    content="Explore the wide range of services provided by AppNexts, including App Development, Web Development, SEO, Graphic Design, Video Editing, and Data Scraping. Empower your business with our innovative digital solutions."
  />
  <meta
    property="og:image"
    content="https://www.appnexts.com/seo_image/our_service_seo.png"
  />
  <meta property="og:url" content="https://www.appnexts.com/our-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AppNexts" />

  {/* Twitter Card Meta Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Our Services | AppNexts - Expert Digital Solutions" />
  <meta
    name="twitter:description"
    content="Discover the powerful digital services offered by AppNexts: app development, SEO, web design, branding, and more to grow your business."
  />
  <meta name="twitter:image" content="https://www.appnexts.com/seo_image/our_service_seo.png" />

  {/* Structured Data (JSON-LD) */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Our Services",
      "url": "https://www.appnexts.com/our-services",
      "description": "Explore the wide range of digital services offered by AppNexts, including App Development, Web Development, SEO, Branding, and more.",
      "publisher": {
        "@type": "Organization",
        "name": "AppNexts",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.appnexts.com/seo_image/appnexts.png"
        }
      },
      "mainEntity": [
        {
          "@type": "Service",
          "name": "App Development",
          "serviceType": "Mobile and Web Application Development",
          "description": "Custom mobile and web apps tailored to your business needs."
        },
        {
          "@type": "Service",
          "name": "Web Development",
          "serviceType": "Responsive Web and E-commerce Development",
          "description": "Responsive, SEO-friendly websites built with the latest technologies."
        },
        {
          "@type": "Service",
          "name": "SEO Services",
          "serviceType": "Search Engine Optimization",
          "description": "Boost your search visibility and organic traffic with our expert SEO solutions."
        },
        {
          "@type": "Service",
          "name": "Graphic Design",
          "serviceType": "Brand Identity & Visual Design",
          "description": "Professional logos, branding materials, and creative visuals."
        },
        {
          "@type": "Service",
          "name": "Video Editing",
          "serviceType": "Promotional & Social Media Video Editing",
          "description": "Engaging video content for ads, reels, intros, and more."
        },
        {
          "@type": "Service",
          "name": "Data Scraping",
          "serviceType": "Automated Data Collection",
          "description": "Automated data extraction for business insights and lead generation."
        }
      ]
    })}
  </script>
</Helmet>





      
      <PageHeader title="Our Services" breadcrumb={[{ label: "Home", path: "/" },{ label: "Services" }]}/>

      

      {/* About Us Section */}
      <main >
       <div>

       <section className=" mx-auto px-4 md:px-6 lg:px-8 bg-white" >
     

      <div className="relative mx-auto max-w-7xl z-10 grid grid-cols-1 gap-10 pt-14 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ">
      {serviceList.map((serviceslist, index) => (
  <div
    key={index}
    className="group bg-[#F7F8FD] rounded-3xl shadow-md border border-white overflow-hidden flex flex-col"
    data-aos="fade-up"
    data-aos-delay={100 * (index + 1)} // Adjust delay based on the index
  >
    <div className="flex flex-1 flex-col p-5">
      <div className="flex justify-between items-center border-b px-2 py-5">
        <h3 className="text-3xl font-semibold w-1/2">{serviceslist.title}</h3>
        <Link
          to={`/services/${serviceslist.slug}`}
          className="w-14 h-14 flex items-center justify-center bg-[#504e9a] text-white rounded-full border border-[#504e9a] transition-transform duration-300 group-hover:text-white relative font-semibold overflow-hidden will-change-transform z-0 group"
        >
          <FaArrowRight className="transition-transform -rotate-45 duration-300 transform group-hover:rotate-0 text-2xl" />
          <span className="absolute inset-0 bg-[#504e9a] rounded-full transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0 will-change-transform z-[-1]"></span>
        </Link>
      </div>
      <p className="text-gray-500 px-2 py-4 ">  {getFirst40Words(serviceslist.description)}</p>
      <Link to={`/services/${serviceslist.slug}`}>
      <img
        src={serviceslist.image}
        alt={serviceslist.title}
        loading="lazy"
        className="w-full object-cover rounded-2xl transition-transform duration-300 group-hover:scale-105"
      />
      </Link>
    </div>
  </div>
))}

      </div>
    </section>

       </div>
       <div className='my-2'>
        <ChooseUsSection />
        </div>
      </main>
      <div className="w-full bg-[#504e9a] text-white py-4 overflow-hidden" >
      <Marquee gradient={false} speed={50}>
        {services.map((service, index) => (
          <div key={index} className="flex items-center mx-4">
            <span className="text-2xl font-bold">{service}</span>
            {index < services.length - 1 && (
              <span className="text-2xl mx-4">•</span>
            )}
          </div>
        ))}
      </Marquee>
    </div>
    <div>
      <Testimonial/>
    </div>
    </div>
  );
};

export default OurService;
